import type { RunSelectionsDto, SelectionsUpdateRequestDto } from '../api/types';

export type RunSelectionDraft = {
  actualHandlers: NonNullable<SelectionsUpdateRequestDto['actualHandlers']>;
  runs: NonNullable<SelectionsUpdateRequestDto['runs']>;
};

export function editRunSelections(selections: RunSelectionsDto): RunSelectionDraft {
  return {
    actualHandlers: selections.actualHandlers.map(handler => ({ ...handler, clientHandlerKey: null })),
    runs: selections.runs.map(({ trialStockOfferId: _offer, ...run }) => ({
      ...run, clientHandlerKey: null,
    })),
  };
}

export function handlerReference(handler: RunSelectionDraft['actualHandlers'][number]): string {
  return handler.actualHandlerId ?? handler.clientHandlerKey ?? '';
}

export function runErrorControlPath(path: string): string {
  return /^(runs|actualHandlers)\[/.test(path) ? `selections.${path}` : path;
}
